import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LiveBettingContext } from 'context/liveBettingContext';
import { LiveEvent } from 'types/LiveEvent';
import styles from './StartedPick.module.css';

interface Props {
  fi: number | string;
}

/**
 * Under a prematch pick whose match has kicked off: says so, and when the
 * match is on the live board, offers to go and take it there.
 */
export const StartedPick = ({ fi }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { events } = useContext(LiveBettingContext);
  const onLive = Array.from(
    (events as Map<number, LiveEvent[]> | undefined)?.values() ?? []
  ).some((list) => list.some((e) => String(e.fi) === String(fi)));

  return (
    <div className={styles.note}>
      <span className={styles.badge}>{t('match_started_label')}</span>
      {onLive && (
        <button
          type="button"
          className={styles.live}
          onClick={() => navigate('/live-betting')}
        >
          {t('take_it_live_label')}
        </button>
      )}
    </div>
  );
};
